import { render } from "./ChatwootWidget.vue?vue&type=template&id=1deb11f9"
import script from "./ChatwootWidget.vue?vue&type=script&lang=js"
export * from "./ChatwootWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__